import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { BackupTableRounded, InsertLink, PictureAsPdf, FolderZip } from "@mui/icons-material";


const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    "& .MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.secondary.dark,
    },
    "& .MuiDataGrid-row:nth-of-type(odd)": {
        backgroundColor: theme.palette.secondary.main,
    },
    "& .MuiDataGrid-row:nth-of-type(even)": {
        backgroundColor: theme.palette.secondary.main,
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: theme.palette.secondary.light,
    },
    "& .MuiDataGrid-cell[data-field='name']": {
        fontWeight: "600",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        fontWeight: "600", // This makes all header titles bold
    },
    fontSize: "13px",
}));

const getIcon = (type) => {
    switch (type) {
        case "PDF":
            return <PictureAsPdf sx={{ color: "#ea4335" }} />;
        case "XLS":
            return <BackupTableRounded sx={{ color: "#117840" }} />;
        case "ZIP":
            return <FolderZip sx={{ color: "#fbbc05" }} />;
        case "LINK":
            return <InsertLink />;
        default:
            return null;
    }
};

export default function RepositoryListDataTable({ data }) {

    // define columns for the DataGrid
    const columns = [
        {
            field: "type",
            headerName: "Type",
            flex: 1,
            maxWidth: 60,
            renderCell: (params) => getIcon(params.value),
        },
        { field: "name", headerName: "Name", flex: 3 },
        { field: "description", headerName: "Description", flex: 5 },
        { field: "updated", headerName: "Updated", flex: 1 },
        { field: "source", headerName: "Source", flex: 1 },
    ];

    const rows = data.map((item, index) => ({
        id: index + 1,
        ...item,
    }));

    const handleRowClick = (params) => {
        const { type, url, name } = params.row;

        if (type === "LINK") {
            window.open(url, "_blank");
        } else if (type === "PDF" || type === "XLS" || type === "ZIP") {
            const link = document.createElement("a");
            link.href = url;
            link.download = name;
            link.click();
        }
    };


    return (
        <Box>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                hideFooter
                onRowClick={handleRowClick}
                style={{ cursor: "pointer" }}
                sx={{
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    "& .MuiDataGrid-cell": {
                        padding: "14px",
                    },
                    "& .MuiDataGrid-columnHeader": {
                        padding: "14px",
                    },
                }}
            />
        </Box>
    );
}
